import { UserPath } from '../Routes/routePaths';

export function isLearnerSessionRoute(pathname) {
  const path = pathname || '';
  return (
    path === UserPath.LearningHub
    || path === UserPath.UserDashboard
    || path === UserPath.RegisteredCoursesRoot
    || path.startsWith(`${UserPath.RegisteredCoursesRoot}/`)
    || path === '/skill-transformation'
    || path.startsWith('/skill-transformation/')
  );
}
